module.exports = "pegasus_template/assets/background-patterns/other-theme.png";